import React from 'react';

export const useHasBeenSeen = (
  element:
    | React.MutableRefObject<HTMLInputElement | undefined>
    | React.RefObject<HTMLDivElement>
    | HTMLElement
    | null,
  seenCallback: () => void,
  disappearCallback: () => void,
  offsetPixels = 0,
): void => {
  React.useEffect(() => {
    if (!element) {
      return;
    }
    const observer = new IntersectionObserver(
      ([entry]) => {
        entry.isIntersecting ? seenCallback() : disappearCallback();
      },
      { rootMargin: offsetPixels + 'px' },
    );
    const myElement =
      element && 'current' in element ? element.current : element;
    if (!myElement) {
      return;
    }
    observer.observe(myElement);
    return () => observer.unobserve(myElement);
  }, []);
};
